module.exports = __webpack_public_path__ + "img/banner-mob.cc21c497.svg";